import { render } from "./NavBar.vue?vue&type=template&id=67dc0c5a&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"

import "./NavBar.vue?vue&type=style&index=0&id=67dc0c5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67dc0c5a"

export default script